import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, Suspense } from "react";
import LeafTabNavLink from "../../common/leaf/LeafTabNavLink/LeafTabNavLink";
import defaultContent from "../../content/customers";
import { CUSTOMER_ROUTES } from "../../routing/SubRoutes/Customers";
import "./Customers.scss";
import { tabMenuClickTrack } from "../../common/tealium/Customers/TabMenuTrack";
import { useAppDispatch } from "../../store";
import { updateSelectorType, SELECTOR_TYPE } from "../../reducers/period";
import LeafRectangleLoader from "../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import { PageTitleSection } from "../../common/components/PageTitleSection/PageTitleSection";
import { BonusInfoFooter } from "../../common/components/BonusInfoFooter/BonusInfoFooter";

const Customers = () => {
  const { t } = useTranslation(["customers"]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateSelectorType(SELECTOR_TYPE.MONTHLY));
  }, [dispatch]);

  const navLinkOnClick = (to: string) => {
    tabMenuClickTrack(to);
  };

  const RouterLoader = () => (
    <div className="router-loader">
      <div className="router-loader-header">
        <LeafRectangleLoader isLoading={true} numRows={1} width="95%" height="3rem" />
      </div>
      <div className="router-loader-top">
        <LeafRectangleLoader isLoading={true} numRows={1} width="95%" height="3rem" />
      </div>
      <div className="router-loader-bottom">
        <LeafRectangleLoader isLoading={true} numRows={1} width="95%" height="8rem" />
      </div>
    </div>
  );

  return (
    <>
      <div className="cml">
        <div className="cml__header">
          <PageTitleSection title={`${t("pageTitle", defaultContent["pageTitle"])}`} />
        </div>
        <div className="cml__scroll">
          <div className="cml__nav">
            <LeafTabNavLink
              tabs={[
                {
                  id: "list",
                  to: CUSTOMER_ROUTES.LIST,
                  text: `${t("customerList", defaultContent["customerList"])}`,
                },
                {
                  id: "order",
                  to: CUSTOMER_ROUTES.ORDER,
                  text: `${t("orderHistory", defaultContent["orderHistory"])}`,
                },
              ]}
              navLinkOnClick={navLinkOnClick}
            />
          </div>
        </div>
        <div className="cml__container">
          <Suspense fallback={<RouterLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
      <BonusInfoFooter />
    </>
  );
};

export default Customers;
